import useFeatureToggles from '@/common/hooks/feature-toggles';

import type { LeafletMapProps } from './custom-background-map/LeafletMap';
import { LeafletMap as LeafletMapWithCustomBackgroundMap } from './custom-background-map/LeafletMap';
import { LeafletMap as LeafletMapWithWebMapBackgroundMap } from './web-map-background-map/LeafletMap';

export const LeafletMap = ({
  children,
  invalidateMapTrigger
}: LeafletMapProps) => {
  const featureToggles = useFeatureToggles();
  return featureToggles.isWebmapBackgroundMapEnabled() ? (
    <LeafletMapWithWebMapBackgroundMap
      invalidateMapTrigger={invalidateMapTrigger}
    >
      {children}
    </LeafletMapWithWebMapBackgroundMap>
  ) : (
    <LeafletMapWithCustomBackgroundMap
      invalidateMapTrigger={invalidateMapTrigger}
    >
      {children}
    </LeafletMapWithCustomBackgroundMap>
  );
};
